import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider, TextField, Grid, Typography, Box, CircularProgress } from "@mui/material"

import { getMfproductStruct, setData } from './MfproductStruct'
import { updateTextValue, handleSubmit, updateValue, updateSelectedValue } from '../../core/js/FormUtils'
import { createAPI, updateAPI, getAPI, updateEditableAPI } from './MfproductAPI';
import { CoreContext } from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { validMobileNumberEntry, validNameEntry, validEmailEntry } from '../../core/js/FormValidation';

import { getPathVariable } from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch, useSelector } from 'react-redux';
import { updateMfproductObj, addMfproductObj, setShowEditForMfproduct, setMfproductAttachImageModal } from 'store/slice/ManufSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { setMessage } from 'store/slice/HeaderSlice';
import AttachImageActionModal from './action/attachImage/AttachImageActionModal';

export default function MfproductEditFormImpl() {
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState(getMfproductStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const { mfproductDashboard } = useSelector((state) => state.manufslice);
    const [mfproductId, setMfproductId] = useState(mfproductDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo)
    const {mfproductObj}    = useSelector((state) => state.manufslice.mfproductDashboard);
    const {selectedImagePath, selectedImage} = useSelector((state) => state.imagegalleryslice);

    const { apiInProgress } = useSelector((state) => state.headerslice);

    const {categoryList} = useSelector((state)=>state.manufslice);
        const handleDynamicSelectedValueForcategoryid = (e) =>{
            updateSelectedValue(formValues, setFormValues,e, 
                'categoryname', e.target.value==0?'Select Item':categoryList.find(obj => obj.id === e.target.value).title);
        }
        
    useEffect(() => {
    }, [apiInProgress])

    useEffect(() => {
        console.log("selectedImage=>" + selectedImage);
        setFormValues({
            ...formValues,
            ['imageurl']: {
                ...formValues['imageurl'],
                value: selectedImagePath
            }
        })
    },[selectedImagePath])

    useEffect(() => {
        if (mfproductId !== -1) {
            if (dataLoaded) return;
            getAPI(mfproductId, loadForm);
        }
        else {
            // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            }
        })
    }, []);

    const setNotification = (message) => {
        dispatch(setMessage(message));
    }
    const loadForm = (data) => {
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value + " == " + getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value)
            return "yes"
        else
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value === "yes")
            return true
        else
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;
        // Remove newlines for the description field

       // const sanitizedValue = value.replace(/[\r\n]+/g, '&#35;');
        
        //const sanitizedValue = value.replace(/[\r\n]+/g, '').replace(/"/g, '&#34;');
        //const sanitizedValue1 = sanitizedValue.replace(/"/g, '\\"'); // Escapes double quotes
        //const sanitizedValue = value.replace(/[\r\n]+/g, '\\n');
        updateTextValue(formValues, setFormValues, { target: { name, value: value } });
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;

        // Do not allow starting with '.'
        if (value.startsWith('.')) {
            return;
        }

        // Allow empty string so user can delete all characters
        if (value === '' || value === '.') {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
            return;
        }

        // Regex: Allow up to 9 digits before decimal, optional decimal, up to 2 digits after decimal (Indian Rupees format)
        const regex = /^\d{0,9}(\.\d{0,2})?$/;

        if (regex.test(value)) {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
        }
    }
    const handleNameChange = (e) => {
        setShowError(false);

        if (validNameEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);

        if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);

        if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }

    const createSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(addMfproductObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForMfproduct(false));
    }
    const updateSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(updateMfproductObj(obj));
        setNotification("'"+mfproductObj.title + "' has been updated successfully !!!");
        dispatch(setShowEditForMfproduct(false));

    }
    const failuerCallback = (errorMsg) => {
        dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) => {
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback);
    }
    const callUpdateAPI = (id, formValues, updateSuccessCallback, failuerCallback) => {
        dispatch(setApiInProgress(true));
        updateAPI(id, formValues, updateSuccessCallback, failuerCallback);
    }
    const transformBeforeSubmit = (formValues) => {
            setFormValues({
            ...formValues,
            ['description']: {
                ...formValues['description'],
                value: formValues.description.value.replace(/[\r\n]+/g, '\\n')
            }
        })
    }
    const onSubmit = (e) => {
        transformBeforeSubmit(formValues);
        handleSubmit(e, mfproductId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callCreateAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);

        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr = date.getFullYear() + "-" + monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    const showImageGallery = () =>{
        dispatch(setMfproductAttachImageModal(true));
    }
    return (
        <form noValidate onSubmit={onSubmit} >
            <Grid container direction="column" >
                {showError ? <Alert severity="error">{errorMsg}</Alert> : ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '60vh', borderRadius:2 }}>
                        <Grid container direction="column" padding={1}>
                            <Grid item>
                                <Typography variant='h4'>{mfproductId === -1 ? 'Add' : 'Edit'} Product </Typography>
                                <Divider />
                            </Grid>
                            <Grid height='15px' ></Grid>
                            {dataLoaded ?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center">
                                    <Grid item lg={4} xs={12} sx={{ padding: 1, height: '100%', borderRight: '1px solid lightgray' }}>
                                        
                                            <Grid container display="flex" direction="column" justifyContent="center" alignItems="center">
                                                <Grid item lg={12} xs={12} sx={{ padding: 1, backgroundColor: 'secondary.200', borderRadius: '5px', height: '100%' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <img
                                                            src={formValues.imageurl.value}
                                                            alt={formValues.imageurl.value === '' ? "Not Found" : formValues.title.value}
                                                            style={{ width: '100%', height: '150px', borderRadius: '5px',}}
                                                        />


                                                    </div>
                                                </Grid>
                                                <Grid item lg={12} xs={12} sx={{ padding: 1, backgroundColor: 'white', }}>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => showImageGallery()}
                                                    >
                                                        Edit
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        
                                    </Grid>
                                    <Grid item lg={8} xs={12}>
                                        <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center">
                                            <Grid item lg={12} xs={12}>
                                                <TextField size="Normal"
                                                    placeholder={formValues.title.placeholder}
                                                    required={formValues.title.required}
                                                    label={formValues.title.label}
                                                    name={formValues.title.name}
                                                    value={formValues.title.value}
                                                    onChange={handleTextChange}
                                                    error={formValues.title.error}
                                                    helperText={formValues.title.error && formValues.title.errorMessage}
                                                    sx={{ width: '100%' }}
                                                />
                                            </Grid>

                                            <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                                <TextField size="Normal"
                                                    placeholder={formValues.imageurl.placeholder}
                                                    required={formValues.imageurl.required}
                                                    label={formValues.imageurl.label}
                                                    name={formValues.imageurl.name}
                                                    value={formValues.imageurl.value}
                                                    onChange={handleTextChange}
                                                    error={formValues.imageurl.error}
                                                    helperText={formValues.imageurl.error && formValues.imageurl.errorMessage}
                                                    sx={{ width: '100%' }}
                                                />
                                            </Grid>

                                            

                                            <Grid item lg={5} xs={6}>
                                                <TextField size="Normal"
                                                    placeholder={formValues.code.placeholder}
                                                    required={formValues.code.required}
                                                    label={formValues.code.label}
                                                    name={formValues.code.name}
                                                    value={formValues.code.value}
                                                    onChange={handleTextChange}
                                                    error={formValues.code.error}
                                                    helperText={formValues.code.error && formValues.code.errorMessage}
                                                    sx={{ width: '100%' }}
                                                />
                                            </Grid>
                                            <Grid item lg={5} xs={6}>
                                                                            <TextField size="Normal"
                                                                                placeholder={formValues.price.placeholder}
                                                                                required={formValues.price.required}
                                                                                label={formValues.price.label}
                                                                                name={formValues.price.name}
                                                                                value={formValues.price.value}
                                                                                onChange={handleDoubleChange}
                                                                                error={formValues.price.error}
                                                                                helperText={formValues.price.error && formValues.price.errorMessage}
                                                                                sx={{width:'100%'}}
                                                                            />
                                                                        </Grid>

                                            <Grid item lg={3} xs={6} sx={{ display: 'none' }}>
                                                <TextField size="Normal"
                                                    placeholder={formValues.stockcount.placeholder}
                                                    required={formValues.stockcount.required}
                                                    label={formValues.stockcount.label}
                                                    name={formValues.stockcount.name}
                                                    value={formValues.stockcount.value}
                                                    onChange={handleTextChange}
                                                    error={formValues.stockcount.error}
                                                    helperText={formValues.stockcount.error && formValues.stockcount.errorMessage}
                                                    sx={{ width: '100%' }}
                                                />
                                            </Grid>
                                            <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                                                            <FormControl sx={{  width:'100%'}} size="Normal">
                                                                                <InputLabel id="demo-simple-select-autowidth-label">{formValues.categoryid.label}</InputLabel>
                                                                                <Select
                                                                                        labelId="demo-simple-select-autowidth-label"
                                                                                        id="demo-simple-select-autowidth"
                                                                                        label={formValues.categoryid.label}
                                                                                        name={formValues.categoryid.name}
                                                                                        value={formValues.categoryid.value}
                                                                                        onChange={handleDynamicSelectedValueForcategoryid}
                                                                                        
                                                                                        error={formValues.categoryid.error}
                                                                                        helpertext={formValues.categoryid.error && formValues.categoryid.errorMessage}
                                                                                        >
                                                                                        <MenuItem key={0} value="0">Select Item</MenuItem>
                                                                                        {
                                                                                            categoryList && categoryList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                                                                        }
                                                                                    </Select>
                                                                            </FormControl> 
                                                                        </Grid>                        
                                                                        <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                                                            <TextField size="Normal"
                                                                                placeholder={formValues.categoryname.placeholder}
                                                                                required={formValues.categoryname.required}
                                                                                label={formValues.categoryname.label}
                                                                                name={formValues.categoryname.name}
                                                                                value={formValues.categoryname.value}
                                                                                onChange={handleTextChange}
                                                                                error={formValues.categoryname.error}
                                                                                helperText={formValues.categoryname.error && formValues.categoryname.errorMessage}
                                                                                sx={{width:'100%'}}
                                                                            />
                                                                        </Grid>

                                            <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                                <TextField size="Normal"
                                                    placeholder={formValues.businessid.placeholder}
                                                    required={formValues.businessid.required}
                                                    label={formValues.businessid.label}
                                                    name={formValues.businessid.name}
                                                    value={formValues.businessid.value}
                                                    onChange={handleTextChange}
                                                    error={formValues.businessid.error}
                                                    helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                                    sx={{ width: '100%', }}
                                                />
                                            </Grid>

                                            <Grid item lg={12} xs={12} sx={{paddingTop:15}}>
                                                <TextField size="Normal"
                                                    placeholder={formValues.description.placeholder}
                                                    required={formValues.description.required}
                                                    label={formValues.description.label}
                                                    name={formValues.description.name}
                                                    value={formValues.description.value.replace(/&#34;/g, '"')}
                                                    onChange={handleTextChange}
                                                    error={formValues.description.error}
                                                    helperText={formValues.description.error && formValues.description.errorMessage}
                                                    sx={{ width: '100%' }}
                                                    multiline // Enables multi-line input
                                                    rows={5} // Sets the number of rows to 5
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                : <></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider />
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                    {apiInProgress ? <CircularProgress /> :
                        <>
                            <Button variant="outlined" type="submit" >{mfproductId === -1 ? 'Add' : 'Save'}</Button>&nbsp;&nbsp;&nbsp;
                            <Button variant="outlined" onClick={() => { dispatch(setShowEditForMfproduct(false)); }}>Close</Button>
                        </>
                    }
                </Grid>
            </Grid>
            <AttachImageActionModal/>
        </form>
    );
};